import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ErrorIcon } from '../../../Assets/Icons/error_icon.svg';
import ToggleComponent from '../../ToggleComponent';
import './select.css';

const Select = React.forwardRef(
  (
    {
      onBlur,
      label,
      onChange,
      value,
      name,
      error,
      onFocus,
      focus,
      showError,
      success,
      disabled,
      required,
      placeholder,
      classes = '',
      options = [{value: "", displayedValue: ''}],
      info = [],
      variant,
      loading,
    },
    ref,
  ) => {

    const commonClasses = 'w-full h-10 rounded px-4 py-2 text-sm text-boudoir outline-none focus:outline-none' ;

    const normalSelect = `border-seal  border ${commonClasses} bg-white select_one`

    const errorSelect = `border-chestNut border focus:border-chestNut ${commonClasses}`;

    const successClass = `${commonClasses} border-jade focus:border-jade`;
    const dullClass = ` ${commonClasses} bg-bleachedSilk select_dull border-none`;
    const borderlessClass = `${commonClasses} border-0`
    return (
      <label className="mb-4 w-full font-sans" htmlFor={name}>
        <ToggleComponent check={label}>
          <span className="leading-6 font-semibold text-sm text-boudoir tracking-wider mb-2 inline-block">
            {label}
          </span>
        </ToggleComponent>
        <span className="relative block">
          <select
            required={required}
            disabled={disabled}
            ref={ref}
            focus={focus.toString()}
            id={name}
            name={name}
            value={value}
            onFocus={onFocus}
            onChange={onChange}
            className={clsx({
              [normalSelect]: !showError && !variant,
              [errorSelect]: !success && showError,
              [successClass]: success,
              [dullClass]: variant === 'dull',
              [borderlessClass]: variant === 'borderless',
              [classes]: true,
            })}
            onBlur={onBlur}
          >
            <option className="text-seal" disabled={!value} selected={!value} hidden value="">{loading ? 'loading' : placeholder}</option>
            {options?.map(({ value, displayedValue }) => (
              <option value={value}>{displayedValue || value}</option>
            ))}
          </select>
          <ToggleComponent check={!success && showError}>
            <span className=" absolute top-1/2 transform -translate-y-1/2 right-0 mr-4">
              <ErrorIcon />
            </span>
          </ToggleComponent>
        </span>

        <span className="text-xs text-text-ruby">
          <ToggleComponent check={!success && showError}>
            <>
              {error &&
                error.map((errorValue) => (
                  <>
                    <span className="text-chestNut ">{errorValue}</span>

                    <br />
                  </>
                ))}
            </>
          </ToggleComponent>
        </span>
        {!showError && info && (
          <span className="text-xs text-text-dark">
            <>
              {info &&
                info.map((infoValue) => (
                  <>
                    <span className=" ">{infoValue}</span>

                    <br />
                  </>
                ))}
            </>
          </span>
        )}
      </label>
    );
  },
);

Select.defaultProps = {
classes: '',
  label: '',
  name: '',
  value: '',
  onFocus: () => {},
  onChange: () => {},
  onBlur: () => {},
  focus: false,
  error: [],
  showError: false,
  success: false,
  disabled: false,
  required: false,
};

Select.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onFocus: PropTypes.func,
  focus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.array, PropTypes.string,
  ]),
  showError: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  classes: PropTypes.string,
};

export default Select;
